/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthScopes } from './AuthScopes';
import {
    AuthScopesFromJSON,
    AuthScopesFromJSONTyped,
    AuthScopesToJSON,
} from './AuthScopes';

/**
 * 
 * @export
 * @interface Scope
 */
export interface Scope {
    /**
     * 
     * @type {string}
     * @memberof Scope
     */
    description: string;
    /**
     * 
     * @type {AuthScopes}
     * @memberof Scope
     */
    name: AuthScopes;
    /**
     * 
     * @type {string}
     * @memberof Scope
     */
    id: string;
}



/**
 * Check if a given object implements the Scope interface.
 */
export function instanceOfScope(value: object): value is Scope {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ScopeFromJSON(json: any): Scope {
    return ScopeFromJSONTyped(json, false);
}

export function ScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Scope {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'name': AuthScopesFromJSON(json['name']),
        'id': json['id'],
    };
}

export function ScopeToJSON(value?: Scope | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'name': AuthScopesToJSON(value['name']),
        'id': value['id'],
    };
}

